<nav
  class="navbar is-fixed-top has-shadow"
  role="navigation"
  aria-label="main navigation"
>
  <div
    class="is-flex is-fullwidth is-flex-direction-column is-justify-content-flex-start is-align-items-stretch"
  >
    <div class="navbar-top has-background-primary is-size-7">
      <div class="container is-fullheight">
        <div
          class="oecd-small-logo is-flex is-align-items-center is-justify-content-flex-start is-fullheight ml-2-touch has-text-light"
        >
          <img
            src="assets/images/oecd-symbol-white.png"
            class="mr-2"
            width="24"
            alt="OECD logo"
          />
          <a
            (click)="isLegalMenuExpanded = !isLegalMenuExpanded"
            class="icon-text"
            class="no-deco"
          >
            <span>An official website of the OECD. Find out more</span>
            <span class="icon">
              <i class="fa-solid fa-caret-down"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
    <div
      [ngClass]="{ 'is-active': isLegalMenuExpanded }"
      class="ribbon has-background-primary is-fullwidth container-full has-text-light content is-small"
    >
      <div class="container py-8 px-4">
        <div class="columns">
          <div class="column is-5 is-offset-1">
            <p class="is-size-6 has-text-weight-bold">
              Created by the OECD Directorate for Science, Technology and
              Innovation
            </p>
            <p>
              This website was created by the OECD Directorate for Science
              Technology and Innovation
              <a
                href="https://www.oecd.org/sti/"
                target="_blank"
                class="has-text-link"
                rel="noopener noreferrer"
                >(STI)</a
              >.
            </p>
          </div>
          <div class="column is-5">
            <p class="is-size-6 has-text-weight-bold">
              How to validate authenticity
            </p>
            <p>
              Validation that this is an official OECD website can be found on
              the
              <a
                href="https://www.oecd.org/sti/rd-tax-stats.htm"
                target="_blank"
                class="has-text-link"
                rel="noopener noreferrer"
                >R&D Tax Incentives</a
              >
              page of the corporate OECD website.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container is-fullwidth">
      <div
        class="navbar-bottom is-flex is-align-items-center is-justify-content-space-between"
      >
        <div class="navbar-brand">
          <a
            class="navbar-item has-text-weight-semibold py-0"
            routerLink="/"
            (click)="toggleMobileMenu(true)"
          >
            <img src="assets/images/logo-innotax.svg" width="270" />
          </a>

          <a
            role="button"
            class="navbar-burger"
            aria-label="menu"
            aria-expanded="false"
            data-target="navbarBasicExample"
            (click)="toggleMobileMenu()"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div class="navbar-menu" [ngClass]="{ 'is-active': showMobileMenu }">
          <div class="navbar-start"></div>

          <div class="navbar-end">
            <div class="navbar-item has-text-weight-semibold">
              <a
                class="navbar-item"
                routerLink="/about"
                (click)="toggleMobileMenu()"
                [ngClass]="{
                  'is-active': activeItem === 'about'
                }"
              >
                About
              </a>
            </div>
            <div
              class="navbar-item has-text-weight-semibold dropdown is-mega"
              [ngClass]="{
                'is-active': isCountryDropdownExtended
              }"
              #countryMenu
            >
              <a
                class="navbar-link"
                [ngClass]="{
                  'is-active':
                    isCountryDropdownExtended || activeItem === 'countries'
                }"
                (click)="isCountryDropdownExtended = !isCountryDropdownExtended"
              >
                Countries
              </a>
              <div class="navbar-dropdown py-5 scroll-vertical">
                <div class="container">
                  <div class="columns my-4">
                    <div class="column is-3 is-2-fullhd is-hidden-touch">
                      <p class="title is-5 has-text-weight-bold mt-1">
                        Find out about a country
                      </p>
                    </div>
                    <div class="columns is-multiline py-4">
                      <div class="column is-12 py-0 is-hidden-desktop">
                        <a
                          class="navbar-item py-2 px-3"
                          (click)="
                              isCountryDropdownExtended =
                                !isCountryDropdownExtended
                            "
                        >
                          <i class="fa-solid fa-square-caret-left mr-2"></i>
                          <span>Back</span>
                        </a>
                      </div>
                      <app-header-countries-loader *ngIf="!countries">
                      </app-header-countries-loader>
                      <div
                        class="column is-12-mobile is-12-touch is-3-desktop py-0"
                        *ngFor="let country of countriesWithPages"
                      >
                        <a
                          routerLink="/countries/{{ country.id }}"
                          class="navbar-item py-2"
                          (click)="
                              isCountryDropdownExtended =
                                !isCountryDropdownExtended;
                              toggleMobileMenu()
                            "
                          [ngClass]="{
                              'is-active': country.id === activeCountry
                            }"
                        >
                          <img
                            class="flag is-small mr-2"
                            src="./assets/images/flags/{{
                                country.image
                              }}.png"
                            alt="{{ country.label }} flag"
                          />
                          <span>{{ country.label }}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="navbar-item has-text-weight-semibold">
              <a
                class="navbar-item"
                [ngClass]="{
                  'is-active': activeItem === 'indicators'
                }"
                routerLink="/indicators-and-analysis"
                (click)="toggleMobileMenu()"
              >
                Indicators and analysis
              </a>
            </div>
            <div class="navbar-item has-text-weight-semibold">
              <a
                class="navbar-item"
                [ngClass]="{
                  'is-active': activeItem === 'incentives'
                }"
                routerLink="/incentives"
                (click)="toggleMobileMenu()"
              >
                Find incentives
              </a>
            </div>

            <div class="navbar-item has-text-weight-semibold">
              <a
                id="my-comparator"
                [ngClass]="{
                  'is-active': activeItem === 'comparator'
                }"
                class="navbar-link is-arrowless is-hidden-touch"
                (click)="isCartOpen = !isCartOpen"
                (dblclick)="goToComparator()"
              >
                Compare incentives
                <span
                  class="tag"
                  [ngClass]="{
                    'ml-2 is-black': favoriteIncentives?.length === 0,
                    'is-link ml-1': favoriteIncentives?.length >= 1
                  }"
                  >{{ favoriteIncentives?.length }}</span
                >
              </a>
              <a
                id="my-comparator"
                class="navbar-link is-arrowless is-hidden-desktop"
                routerLink="/comparator"
                (click)="toggleMobileMenu()"
              >
                My comparator
                <span
                  class="tag"
                  [ngClass]="{
                    'ml-2 is-black': favoriteIncentives?.length === 0,
                    'is-link ml-1': favoriteIncentives?.length >= 1
                  }"
                  >{{ favoriteIncentives?.length }}</span
                >
              </a>
            </div>
          </div>

          <app-cart
            [favoriteIncentives]="favoriteIncentives"
            [lastAddedIncentives]="lastAddedIncentives"
            [isCartOpen]="isCartOpen"
            (onCloseModal)="isCartOpen = false"
          ></app-cart>
        </div>
      </div>
    </div>
  </div>
</nav>
